import type { PluginExtensionAddedFunctionConfig } from '@grafana/data';

export type CallbackFunction = () => FunctionNamespace[];
export type FunctionImplementation = (...args: any[]) => any;
export const CALLBACK_EXTENSION_POINT = 'grafana-assistant-app/callback/v0-alpha';

export type NamedFunctions = Record<string, FunctionImplementation>;
export type FunctionNamespace = {
  namespace: string;
  functions: NamedFunctions;
};

export function newFunctionNamespace(namespace: string, functions: NamedFunctions): FunctionNamespace {
  return {
    namespace,
    functions,
  };
}

export function getExposeAssistantFunctionsConfig(
  namespaces: FunctionNamespace[]
): PluginExtensionAddedFunctionConfig<() => FunctionNamespace[]> {
  return {
    title: 'callback',
    targets: [CALLBACK_EXTENSION_POINT],
    fn: () => {
      return namespaces.map((namespace) => {
        return {
          namespace: namespace.namespace,
          functions: namespace.functions,
        };
      });
    },
  };
}
